<template>
  <div class="samplesRoot">
    <div class="sampPart1">
      <span class="font23">案例展示</span>
      <span class="font24">时空视界部分项⽬案例展示与分析</span>
    </div>

    <!-- <div class="sampPart2">
				<div class="sampPart2Left"></div>
				<div class="sampPart2Right">
					<span class="font25">智慧应急指挥管理平台</span>
					<span class="font26">
						系统依托大数据可视化技术和多维数据融合分析能力突出实战
						应用功能，构建应急大数据治理体系，建设数据资源池，支撑
						各类应急业务系统和数据分析应用。围绕应急态势总览、应急
						大数据决策支撑、应急救援指挥、应急事件复盘等主要功能模
						块，搭建了一整套基于三维一张图的应急管理、预警、指挥、
						调度、预案、演练、重建等全业务为周期的应用平台，可应用
						于森林防火、防汛抗旱、地质灾害、危险源监测等场景。
					</span>
				</div>
			</div> -->

    <div class="sampPart3">
      <span class="font27">智慧环保可视化平台</span>
      <span class="font28">
        该平台整合环保企业及相关⾏业的多源信息数据资源，通过多层级数据可视化展示，实现对⼤⽓、⽔质、⼟壤等环境监测数据的集中管理与⾼效分析。系统采⽤先进的⼈机交互与数据融合技术，⽀持多维度数据展示、趋势分析与智能预警，帮助企业优化⽣产过程中的环境管理，提升绿⾊运营⽔平。平台可⼴泛应⽤于环保产业链企业、能源企业、农业⽣产及⽣态管理等多种场景。
      </span>
      <div class="sampPart3Img"></div>
    </div>

    <div class="sampPart4">
      <div class="sampPart4Img"></div>
      <span class="font29"> ⽣产企业综合管理平台 </span>
      <span class="font30">
        该平台通过多源数据融合与可视化分析，实现对⽣产过程的全⽅位监测、数据分析与态势展示。系统帮助企业提升⽣产运营效率，实现精细化管理、科学化决策与⾼效协同。平台⽀持远程访问与统⼀管理，可整合⽣产部⻔现有的信息系统及数据资源，为企业提供可靠的⽣产数据⽀撑与可视化决策⼯具。可⼴泛应⽤于制造业、能源、装备、数据分析与展示等多种业务场景。
      </span>
    </div>

    <div class="sampPart5">
      <span class="font27"> 企业级三维空间可视化管理平台 </span>
      <span class="font28">
        该系统融合时空⼤数据云平台、城市信息模型（CIM）平台及三维空间规划管理系统等多源数据，整合多维、多空间信息模型和实时感知数据，为企业提供先进的三维空间可视化与管理⼯具。平台可⾼效展示区域空间规划从论证、设计、建设到运营的全⽣命周期过程，帮助企业实现空间数据资产的数字化、可视化和智能化管理，成为产业园区、地产开发、⼯程建设及数字孪⽣应⽤的重要技术⽀撑系统。
      </span>
      <div class="sampPart5Img"></div>
    </div>

    <div class="sampPart6">
      <div class="sampPart6Left"></div>
      <div class="sampPart2Right">
        <span class="font25">区域数字沙盘</span>
        <span class="font26">
          系统采⽤3D GIS、云计算、⼈⼯智能、数字孪⽣、⼤数据等技术，以三维地理实体为基础，结合各类数据，集成⼤数据形成智慧区域数字底盘，将区域数据、建设规划成果展示、数据分析研判等多种场景在时空⼤数据三维⼀张图平台上呈现，实现区域智慧式管理和运⾏。
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Samples',
  mounted() {
    document.title = '时空视界|案例'

    if (window.createdCallBack) {
      window.createdCallBack(true)
    }
    if (window.updateNavCallBack) {
      window.updateNavCallBack(2)
    }
  },
}
</script>

<style scoped="scoped">
.sampPart6Left {
  width: 50%;
  height: 800px;
  background-image: url(../../assets/samples/pic_szsp.jpg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: inline-block;
}
.sampPart6 {
  height: 800px;
  text-align: left;
}
.sampPart5Img {
  background-image: url(../../assets/samples/pic_csgh.png);
  background-size: contain;
  width: 50%;
  height: 67.55%;
  /* position: absolute; */
  margin-left: 50%;
  padding-top: 19.5%;
  background-repeat: no-repeat;
  background-position: center;
}
.sampPart5 {
  height: 800px;
  background-color: #ededed;
}
.sampPart4Img {
  background-image: url(../../assets/samples/pic_shengchan.png);
  background-size: contain; /*cover;*/
  background-position: center;
  background-repeat: no-repeat;
  height: 864px;
  width: 1200px;
  position: absolute;
  float: left;
  margin-top: 14px;
}
.font30 {
  width: 33.75%;
  height: 240px;
  font-size: 24px;
  /* font-family: SourceHanSansK-Normal; */
  font-weight: 400;
  color: #d3d3d3;
  line-height: 40px;
  display: block;
  padding-left: 58.5%;
  padding-top: 2%;
  text-align: left;
}
.font29 {
  font-size: 50px;
  /* font-family: SourceHanSansK-Medium; */
  font-weight: 500;
  color: #ffffff;
  line-height: 75px;
  letter-spacing: 2px;
  display: block;
  text-align: left;
  padding-left: 58.5%;
  padding-top: 11.5%;
  width: 33.75%;
}
.sampPart4 {
  height: 800px;
  background-color: #1d1d20;
}
.sampPart3Img {
  background-image: url(../../assets/samples/pic_huanbao.png);
  background-size: contain;
  width: 960px;
  height: 67.55%;
  /* position: absolute; */
  margin-left: 50%;
  padding-top: 19.5%;
  background-repeat: no-repeat;
  background-position: center;
}
.font28 {
  width: 624px;
  font-size: 24px;
  /* font-family: SourceHanSansK-Normal; */
  font-weight: 400;
  color: #3a3a3a;
  line-height: 40px;
  display: block;
  text-align: left;
  padding-left: 202px;
  padding-top: 343px;
  position: absolute;
}
.font27 {
  width: 578px;
  font-size: 50px;
  /* font-family: SourceHanSansK-Medium; */
  font-weight: 600;
  color: #000000;
  line-height: 50px;
  letter-spacing: 2px;
  display: block;
  text-align: left;
  padding-left: 202px;
  padding-top: 217px;
  position: absolute;
}
.sampPart3 {
  height: 800px;
  background-color: #ededed;
}
.font26 {
  width: 648px;
  font-size: 24px;
  /* font-family: SourceHanSansK-Normal; */
  font-weight: 400;
  color: #3a3a3a;
  line-height: 40px;
  display: block;
  margin-left: 17%;
  margin-top: 76px;
}
.font25 {
  font-size: 50px;
  /* font-family: SourceHanSansK-Medium; */
  font-weight: 500;
  color: #000000;
  line-height: 50px;
  letter-spacing: 2px;
  display: block;
  margin-left: 17%;
  margin-top: 21%;
}
.sampPart2Right {
  width: 960px;
  height: 800px;
  position: absolute;
  display: inline-block;
}
.sampPart2Left {
  width: 960px;
  height: 800px;
  background-image: url(../../assets/samples/pic_xmyj.jpg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: inline-block;
}
.sampPart2 {
  height: 800px;
  text-align: left;
}
.font24 {
  height: 20px;
  font-size: 20px;
  /* font-family: SourceHanSansK-Regular; */
  color: #d3d3d3;
  display: block;
  text-align: center;
  margin-top: 20px;
}
.font23 {
  font-size: 50px;
  /* font-family: SourceHanSansK-Medium; */
  font-weight: 500;
  color: #ffffff;
  line-height: 75px;
  letter-spacing: 2px;
  display: block;
  padding-top: 79px;
}
.sampPart1 {
  background-image: url(../../assets/samples/pic_head.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 800px;
}
.samplesRoot {
  text-align: center;
  margin-bottom: -4px;
  width: 1920px;
}
</style>
